module.exports = __webpack_public_path__ + "teqbahn-assets/media/footer2.f1ad53fd.png";